import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { MatDatepickerInputEvent, MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { NotificationsService } from "angular2-notifications";
import { UserService } from "../services/user.service";
import { ReportService } from "../services/report.service";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import * as moment from 'moment';
import * as XLSX from 'xlsx';
import { ProperJsonDialogComponent } from '../properJsonDialog/properjsondialog.component';
import { EditCollateralDepositDialog } from './edit-collateral-deposit/edit-collateral-deposit.component';
import { MultiplierDialog } from "./multiplier/multiplier.component";

@Component({
  selector: 'app-collateral-deposit',
  templateUrl: './collateral-deposit.component.html',
  styleUrls: ['./collateral-deposit.component.css']
})
export class CollateralDepositComponent implements OnInit {

  displayedColumns = [
    'data',
    'user_name',
    'admin_name',
    'assetId',
    'amount',
    'multiplier',
    'multiplier_amount',
    'status',
    'timestamp',
    'txnId',
    'sourceId',
    'sourceName',
    'note',
    'txHash',
    'createdAt'
  ];

  filter: any = {
    fDate: moment().subtract(7,'d').format('yyyy-MM-DD'),
    tDate: moment().format('yyyy-MM-DD')
  };
  dataSource: MatTableDataSource<any>;
  pageSize = 25;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  permission: String;

  constructor(private notifSer: NotificationsService,
    private userService: UserService,
    private spinnerService: Ng4LoadingSpinnerService,
    private router: Router, 
    private reportService: ReportService,
    public dialog: MatDialog,
    private notif: NotificationsService) { }

  ngOnInit() {
    if (!this.userService.isLoggedIn()) {
      this.router.navigateByUrl('/index');
    } else {
      if (typeof localStorage.getItem('adminmenus') != 'undefined' && localStorage.getItem('adminmenus').length > 0) {
        var spt = this.router.url.split("/");
        var menu_url = spt[1];
        var adminmenus = JSON.parse(localStorage.getItem('adminmenus'));
        var adminrules = JSON.parse(localStorage.getItem('adminrules'));
        var index = adminmenus.findIndex(x => (x.menu_url) === menu_url);
        if (index != -1) {
          var menuid = adminmenus[index]._id;
          var adindex = adminrules.findIndex(x => (x.menu_id) === menuid.toString());
          this.permission = (adindex != -1) ? adminrules[adindex].permission : "write";
        }
      }
    }
    this.csrf();
  }
  csrf() {
    this.userService.csrf().subscribe((success) => {
      this.filter._csrf = success._csrf;

      this.getCollateralDeposit();
    }, (error) => {
      if (error.status > 0) {
        this.notif.error(
          'CSRF',
          error.error.message,
          {
            timeOut: 5000,
            showProgressBar: true,
            pauseOnHover: true,
            clickToClose: true,
            maxLength: 50
          }
        )
      }
    })
  }

  displayProperJson(jsonData, eventType) {
    let obj = {
        jsonData: jsonData,
        eventType: eventType
    }
    this.dialog.open(ProperJsonDialogComponent, {
        width: 'auto',
        height: 'auto',
        data: obj,
    }).afterClosed().subscribe(result => {
    });
  }
  editCollateralDeposit(element) {
    if(element.userid == ''){
      this.dialog.open(EditCollateralDepositDialog, {
        width: 'auto',
        data: element,
    }).afterClosed().subscribe(result => {
        if (result) {
          this.getCollateralDeposit();
        }
    });
    }else{
      this.dialog.open(MultiplierDialog, {
        width: 'auto',
        data: element,
    }).afterClosed().subscribe(result => {
        if (result) {
          this.getCollateralDeposit();
        }
    });
    }
  }

  fromDateFilter(event: MatDatepickerInputEvent<Date>) {
    this.filter['fDate'] = moment(event.value).format('yyyy-MM-DD');
  }
  toDateFilter(event: MatDatepickerInputEvent<Date>) {
    this.filter['tDate'] = moment(event.value).format('yyyy-MM-DD');
  }
  applyFilter(filterValue: string) {
      filterValue = filterValue.trim(); // Remove whitespace
      filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
      this.dataSource.filter = filterValue;
  }

  getCollateralDeposit() {
    this.reportService.getCollateralDeposit(this.filter).subscribe((success) => {
      if (success.status) {
        let collateralDepositDataSource = success.deposit.map(collateralDeposit => {
          if (collateralDeposit && collateralDeposit.data) {
              let parseData = collateralDeposit.data;

              if (collateralDeposit.event_type === 'TRANSACTION_STATUS_UPDATED' || collateralDeposit.event_type === 'TRANSACTION_CREATED') {
                  collateralDeposit.txnId = parseData.id ? parseData.id : '-';
              }
              if (collateralDeposit.event_type === 'VAULT_ACCOUNT_ADDED') {
                  collateralDeposit.sourceId = parseData.id;
                  collateralDeposit.sourceName = parseData.name;
              } else if (collateralDeposit.event_type === 'VAULT_ACCOUNT_ASSET_ADDED') {
                  collateralDeposit.sourceId = parseData.accountId;
                  collateralDeposit.sourceName = parseData.accountName;
              }
              if (parseData.source) {
                  collateralDeposit.sourceId = parseData.source.id || '';
                  collateralDeposit.sourceName = parseData.source.name || '';
              }
              if (parseData.destination) {
                  collateralDeposit.destinationId = parseData.destination.id || '';
                  collateralDeposit.destinationName = parseData.destination.name || '';
              }

              collateralDeposit.assetId = parseData.assetId;
              collateralDeposit.amount = parseData.amount;
              collateralDeposit.status = parseData.status;
              collateralDeposit.subStatus = parseData.subStatus;
              collateralDeposit.note = collateralDeposit.note;
              //collateralDeposit.destinations =JSON.stringify(parseData.destinations)  || '';
              collateralDeposit.txHash = parseData.txHash;
          }
          collateralDeposit.timestamp = moment(collateralDeposit.timestamp).format('MM/DD/YY h:mm:ss A');
          return collateralDeposit
      })
        this.dataSource = new MatTableDataSource(collateralDepositDataSource);
        this.dataSource.paginator = this.paginator
        this.dataSource.sort = this.sort;
      }
    });
  }

  exportExcel(ref: string) {
    this.reportService.getCollateralDeposit(this.filter).subscribe((success) => {
      if (success.status) {
      let exportreflist = [];
        for (let i = 0; i < success.deposit.length; i++) {
          exportreflist.push({
            'User Name': success.deposit[i].user_name ? success.deposit[i].user_name : '',
            'Admin Name': success.deposit[i].admin_name ? success.deposit[i].admin_name : '',
            'Asset Id': success.deposit[i].assetId ? success.deposit[i].assetId : '' ,
            'Amount': success.deposit[i].amount ? success.deposit[i].amount : '',
            'Multiplier': success.deposit[i].multiplier ? success.deposit[i].multiplier : '',
            'Multiplier Amount': success.deposit[i].multiplier_amount ? success.deposit[i].multiplier_amount : '',
            'Status': success.deposit[i].status ? success.deposit[i].status : '',
            'txnId': success.deposit[i].txnId ? success.deposit[i].txnId : '',
            'sourceId': success.deposit[i].sourceId ? success.deposit[i].sourceId : '',
            'sourceName': success.deposit[i].sourceName ? success.deposit[i].sourceName : '',
            'note': success.deposit[i].note ? success.deposit[i].note : '',
            'txHash': success.deposit[i].txHash ? success.deposit[i].txHash : '',
            'CreatedAt': success.deposit[i].createdAt ? success.deposit[i].createdAt : '',
          })
        }
        let fileName = 'Collateral Deposit Report.xlsx';
        console.log(exportreflist)
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportreflist);
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        /* save to file */
        XLSX.writeFile(wb, fileName);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/collateral-deposit/collateral-deposit.component.ts